import styled from "styled-components";

import Input from "components/Input";

export const PaymentForm = styled.form`
  width: 26.5rem;
  height: 27.8125rem;
  padding: 1rem;
  background: var(--black-200);
  border-radius: 0.25rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;

  div {
    margin-bottom: 1rem;
  }

  button {
    margin-top: 3rem;
  }
`;

export const InputStyled = styled(Input)`
  align-items: flex-start;
  justify-content: flex-start;

  input {
    width: 100%;
  }
`;
